/**
 * 各平台表单通用的 shopList 获取逻辑
 * 优先级：组合铺货 > 批量铺货选中的店铺 > 铺货日志单店 > 平台授权店铺
 */
import { mapGetters } from 'vuex'

export default {
  inject: {
    selectShopList: { default: undefined },
  },
  computed: {
    ...mapGetters(['shops_authorizedShops']),
  },

  methods: {
    /**
     * 获取当前平台的店铺列表
     * @param {string} platform - 平台标识（如 'tb', 'pdd'）
     * @returns {Array} 过滤后的店铺列表
     */
    getShopList(platform) {
      // 组合铺货模式：使用外部传入的 shopsList
      if (this.isGroupPuhuo) {
        return this.shopsList || []
      }

      // 批量铺货入口：只显示勾选的店铺
      const selectList = typeof this.selectShopList === 'function'
        ? this.selectShopList()
        : this.selectShopList
      if (selectList && selectList.length) {
        return selectList.filter(item => item.source === platform)
      }
      // 铺货日志入口：只显示对应店铺
      if (this.rowData?.isFromLog) {
        return this.shops_authorizedShops(platform).filter(item => item.id == this.rowData.shopId)
      }

      // 默认：返回平台所有授权店铺
      let otherShopList = []
      if(platform === 'fxg') {
        otherShopList = this.shops_authorizedShops('fxg_gx')
      }
      return [...this.shops_authorizedShops(platform), ...otherShopList]
    },

    /**
     * 合并当前数据和原始数据中未显示店铺的部分
     *
     * 用法：
     * // 当前数据是数组
     * brandList: this.mergeHiddenShopData(cloneDeep(_formdata.brandList) || [], this.originalBrandList, this.shopList)
     *
     * // 当前数据是 JSON 字符串
     * templateConfig: this.mergeHiddenShopData(JSON.parse(this.handleTemplateConfig()), this.originalTemplateConfig, this.shopList)
     *
     * @param {Array} current - 当前表单中该字段的数据（数组）
     * @param {Array|null} original - data() 中存储的原始数据（用于恢复隐藏店铺）
     * @param {Array} shopList - 当前显示的店铺列表（用于补全未填写的店铺数据）
     * @returns {Array} 合并后的数据
     */
    mergeHiddenShopData(current, original, shopList) {
      current = current || []
      if (!original || !original.length) return current
      const visibleShopIds = new Set((shopList || []).map(item => String(item.id || item.shopId)))
      // 恢复被隐藏（不在 visibleShopIds 中）的店铺数据
      const hidden = original.filter(item => !visibleShopIds.has(String(item.shopId)) && !current.some(c => c.shopId == item.shopId))
      
      const merged = [...current, ...hidden]
      const seen = new Set()
      return merged.filter(item => {
        const id = String(item.shopId)
        if (seen.has(id)) return false
        seen.add(id)
        return true
      })
    },
  },
}
